/**
 * @typedef {Object} MenuItem
 * @property {string} name - The name of the menu item
 * @property {string} route - The route of the menu item
 * @property {string} icon - The icon of the menu item
 * @property {boolean} submenu - Whether the menu item has a submenu
 * @property {MenuItem[]} submenuItems - The submenu items of the menu item
 */

import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouteDefinition[]} */
const coreRoutes = [
    {
        path: "/",
        component: () => import("./Security/Login/Login.svelte"),
        secure: false,
        title: "Home" // calls to login will send the person to home
    },
    {
        path: "/login",
        component: () => import("./Security/Login/Login.svelte"),
        secure: false,
        title: "Login"
    },
    {
        path: "/logout",
        component: () => import("./Security/Logout/Logout.svelte"),
        secure: false,
        title: "Logout"
    },
    {
        path: "/reset-password",
        component: () => import("./Security/PasswordResetSubmit/PasswordResetSubmit.svelte"),
        secure: false,
        title: "Password Reset"
    },
    {
        action: ACTIONS.DASHBOARD_VIEW,
        component: () => import("./Dashboard/Dashboard.svelte"),
        title: "Dashboard"
    },
    {
        action: ACTIONS.MESSAGE_LIST,
        component: () => import("./Messages/Messages.svelte")
    },
    {
        action: ACTIONS.PERSONS_SERVED_LIST,
        component: () => import("./PersonsServed/List/PersonsServedList.svelte")
    },
    {
        action: ACTIONS.PROVIDER_DETAILS_VIEW,
        component: () => import("./Providers/Form/ProviderForm.svelte")
    },
    {
        action: ACTIONS.PROVIDERS_LIST,
        component: () => import("./Providers/List/ProvidersList.svelte"),
        title: "Service Providers"
    },
    {
        action: ACTIONS.USER_DETAILS_REQUEST,
        component: () => import("./Users/RequestNewUser/RequestNewUser.svelte")
    },
    {
        action: ACTIONS.USERS_LIST,
        component: () => import("./Users/List/UsersList.svelte")
    },
    {
        action: ACTIONS.USER_DETAILS_VIEW,
        component: () => import("./Users/Profile/UserProfile.svelte")
    }
];

export default coreRoutes;